export function shouldBlockGhostMessages(
  redactMessageHistory?: boolean,
  customerProductType?: string
): boolean {
  if (!redactMessageHistory) return false
  return !['Sales Enablement', 'Legacy'].includes(customerProductType ?? '')
}
